var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{attrs:{"id":"app"}},[_c('NavBar'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{style:({ minHeight: '100vh' }),attrs:{"id":"appContent"}})],1),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }